import { ref, set } from 'firebase/database';
import { database } from '../firebase';

export const editSession: (
    sessionId: string,
    year: number,
    month: number,
    day: number,
    hour: number,
    minute: number,
    capacity: number,
    description: string,
    difficulty: string,
    online: boolean,
    address: string,
) => Promise<void> = async (
    sessionId,
    year,
    month,
    day,
    hour,
    minute,
    capacity,
    description,
    difficulty,
    online,
    address,
) => {
    try {
        set(ref(database, `sessions/${sessionId}/year`), year);
        set(ref(database, `sessions/${sessionId}/month`), month);
        set(ref(database, `sessions/${sessionId}/day`), day);
        set(ref(database, `sessions/${sessionId}/hour`), hour);
        set(ref(database, `sessions/${sessionId}/minute`), minute);
        set(ref(database, `sessions/${sessionId}/capacity`), capacity);
        set(ref(database, `sessions/${sessionId}/description`), description);
        set(ref(database, `sessions/${sessionId}/difficulty`), difficulty);
        set(ref(database, `sessions/${sessionId}/online`), online);
        set(ref(database, `sessions/${sessionId}/location`), address);
    } catch (err) {
        throw Error('Něco se nepovedlo.');
    }

    return;
};
